/* eslint-disable import/prefer-default-export */
import { computed } from 'vue';
import { useBrand } from '@composables/useBrand';
import { useProductFlags } from '@modules/featureControl';
import { getProductType } from '@modules/add-to-bag/utils';
import { useATBUTagMCOM } from './useATBUTag.mcom';
import { useATBUTagBCOM } from './useATBUTag.bcom';

/**
 * * Composable that returns the ATB Utag data
 */
export const useATBUTag = () => {
  const { isMasterProductFlag, isMemberOfMasterFlag, isMemberProduct } = useProductFlags();
  const { isMcom } = useBrand();

  const productType = getProductType({
    isMasterProductFlag,
    isMemberOfMasterFlag,
    isMemberProduct,
  });
  const baseData = isMcom ? useATBUTagMCOM() : useATBUTagBCOM();

  return computed(() => ({
    product_type: [productType],
    ...baseData.value,
  }));
};
